import { template as template_f70d26993e31403aa09034522297fc4a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { provide, consume } from 'ember-provide-consume-context';
import { eq } from '@cardstack/boxel-ui/helpers';
import type { ResolvedCodeRef } from '@cardstack/runtime-common';
import { CardContextName, DefaultFormatsContextName, CardURLContextName, GetCardContextName, GetCardsContextName, GetCardCollectionContextName, type getCard, type getCards, type getCardCollection } from '@cardstack/runtime-common';
import HeadFormatPreview from '@cardstack/host/components/head-format-preview';
import type { BaseDef, Format, Field, CardContext } from 'https://cardstack.com/base/card-api';
interface Signature {
    Element: any;
    Args: {
        card: BaseDef;
        format?: Format;
        field?: Field;
        codeRef?: ResolvedCodeRef;
        displayContainer?: boolean;
    };
}
export default class CardRenderer extends Component<Signature> {
    @consume(GetCardContextName)
    private getCard: getCard;
    @consume(GetCardsContextName)
    private getCards: getCards;
    @consume(GetCardCollectionContextName)
    private getCardCollection: getCardCollection;
    @consume(CardContextName)
    private cardContext: CardContext;
    @provide(DefaultFormatsContextName)
    get defaultFormat() {
        let { format } = this.args;
        format = format ?? 'isolated';
        return {
            cardDef: format,
            fieldDef: format
        };
    }
    @provide(CardURLContextName)
    private get cardURL() {
        return 'id' in this.args.card ? (this.args.card?.id as string | undefined) : undefined;
    }
    static{
        template_f70d26993e31403aa09034522297fc4a(`
    {{#if (eq @format 'head')}}
      <HeadFormatPreview
        @renderedCard={{this.renderedCard}}
        @cardURL={{this.cardURL}}
      />
    {{else}}
      <this.renderedCard
        @displayContainer={{@displayContainer}}
        ...attributes
      />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    get renderedCard() {
        return this.args.card.constructor.getComponent(this.args.card, this.args.field, this.args.codeRef ? {
            componentCodeRef: this.args.codeRef
        } : undefined);
    }
}
